import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import BookingCategory from './BookingCategory.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

function BookingCategoryGroup(props) {

    let nrOfCategories = 0;

    function getGroup() {
        if (!props.groupName) return null;
        return props.groupName.charAt(0).toUpperCase() +
            props.groupName.slice(1).toLowerCase();
    }

    function isEmptyGroup() {
        return getGroup() === 'Missing-group';
    }

    function getCategoryData() {
        return props.customerData.categories;
    }

    function compareNames(name1, name2) {
        if (!name1 && !name2) return true;
        if ((!name1 && name2) || (name1 && !name2)) return false;
        return name1.toUpperCase() === name2.toUpperCase();
    }

    const categories = getCategoryData().map((cat) => {
        if (compareNames(cat.OnlineTypeGroup, getGroup())) {
            nrOfCategories++;
            return (
                <BookingCategory
                    key={cat.BookingTypeId}
                    id={cat.BookingTypeId}
                    onSelect={props.onSelect}
                    data={cat} />

            )
        } else if (!cat.OnlineTypeGroup && isEmptyGroup()) {
            return (
                <BookingCategory
                    key={cat.BookingTypeId}
                    id={cat.BookingTypeId}
                    onSelect={props.onSelect}
                    data={cat} />
            )
        }
        else {
            return <React.Fragment key={cat.BookingTypeId}></React.Fragment>;
        }
    });

    function groupHasCategories() {
        return nrOfCategories > 0;
    }

    if (isEmptyGroup()) {
        return <React.Fragment>{categories}</React.Fragment>;
    }
    else if (!groupHasCategories()) {
        return <React.Fragment></React.Fragment>;
    }
    else {
        return (
            <Accordion style={{ marginBottom: '10px' }}>
                <Card>
                    <Accordion.Toggle
                        style={{ cursor: 'pointer', backgroundColor: '#93c178' }}
                        as={Card.Header}
                        variant="link"
                        eventKey={getGroup()}>
                        <FontAwesomeIcon icon={faPlus} style={{ marginRight: 10 }} />{getGroup()}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={getGroup()}>
                        <React.Fragment>
                            {categories}
                        </React.Fragment>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        );
    }
}

export default BookingCategoryGroup;